import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE =
  window.__RUNTIME_CONFIG__?.apiBase ||
  process.env.REACT_APP_API_BASE ||
  "http://127.0.0.1:5000";

// Landing page for single sign-on from the Spectacles dashboard portal.
// The dashboard sends people to /sso#t=<signed pass>; the pass is in the URL
// fragment so it never reaches server/proxy logs. It's exchanged for a normal
// staff login and stored exactly like Login.jsx does. Any failure falls back
// to the normal login page with the reason shown.
export default function SsoLanding() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("t") || "";
    // Drop the pass from the address bar / history straight away.
    window.history.replaceState(null, "", window.location.pathname);

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const response = await fetch(`${API_BASE}/api/auth/sso`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.error || "Single sign-on failed");

        localStorage.setItem("portalToken", data.access_token);
        localStorage.setItem(
          "portalUser",
          JSON.stringify({ name: data.user_name, email: data.user_email, role: data.role })
        );
        navigate("/dashboard", { replace: true });
      } catch (err) {
        setError(err.message || "Single sign-on failed");
      }
    })();
  }, [navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
                  background: "#faf5fc", fontFamily: "inherit", padding: 16 }}>
      <div style={{ background: "#fff", border: "1px solid #e0d4e8", borderRadius: 12, padding: 28,
                    maxWidth: 380, width: "100%", textAlign: "center" }}>
        {error ? (
          <>
            <p style={{ color: "#c0392b", margin: "0 0 16px" }}>{error}</p>
            <button
              type="button"
              onClick={() => navigate("/login", { replace: true })}
              style={{ padding: "10px 20px", background: "#9c27b0", color: "#fff", border: "none",
                       borderRadius: 8, fontWeight: 700, cursor: "pointer" }}
            >
              Go to sign in
            </button>
          </>
        ) : (
          <p style={{ color: "#666", margin: 0 }}>Signing you in to TalentPool…</p>
        )}
      </div>
    </div>
  );
}
